// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invitation-sent[data-v-eade67ae] {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  color: rgba(0, 0, 0, 0.8784313725);\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
